import { FC, useCallback, MouseEvent, ChangeEvent } from "react";
import { Field } from "../FieldHandler";

const CheckboxField: FC<{
  field: Field & { type: "checkbox" };
  onChange: (key: string, value: boolean) => void;
}> = ({ onChange, field }) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLLabelElement> | ChangeEvent) => {
      e.preventDefault();
      onChange(field.key, !field.value);
    },
    [onChange, field]
  );

  return (
    <span>
      <label className="label-switch" onClick={handleClick}>
        <input type="checkbox" checked={field.value || false} onChange={handleClick} />
        <div className="checkbox"></div>
      </label>
    </span>
  );
};

export default CheckboxField;
